$(document).on("turbolinks:load", function () {
  if (window.innerWidth >= 810) return true;

  let activeBottomsheet = void 0;

  const filters = $(".page-filter").find($("*[data-page-filter]"));

  filters.each((index, filter) => {
    $(filter).on("click", function (e) {
      const filterKey = filter.getAttribute("data-page-filter");
      const bottomsheetTitle = $(filter)
        .children(".dropdown-select-label")
        .clone();
      const bottomsheet = $('<div class="bottomsheet" />');

      $(bottomsheetTitle).find("i").remove();

      const bottomsheetHeader = $(
        `<div class="bottomsheet-header"><div class="bottomsheet-title h3">${$(
          bottomsheetTitle
        ).html()}</div><button type="button" class="bottomsheet-close" data-action="bottomsheet-close"></button></div`
      );
      $(bottomsheet).append(bottomsheetHeader);
      const bottomsheetContent = jQuery.extend(
        {},
        $(filter).children().last().clone()
      );
      $("body").append(
        $(bottomsheet).append(
          $(bottomsheetContent).addClass("bottomsheet-content")
        )
      );

      window.forms.listenInputs();

      let isHasCganges = false;
      let selectedItems = [];
      let appliedItems = [];
      let suggestionItemsFeatured = [];
      const suggestions = $(bottomsheet).find('*[data-ui="suggestions"]')[0];
      const clear = $(bottomsheet).find('*[data-action="filter-clear"]')[0];
      const cancel = $(bottomsheet).find('*[data-action="filter-cancel"]')[0];
      const apply = $(bottomsheet).find('*[data-action="filter-apply"]')[0];
      const bottomsheetCloseTrigger = $('*[data-action="bottomsheet-close"]');

      $(cancel).remove();

      activeBottomsheet = bottomsheet;

      openBottomsheet(filter, {
        sorter: $(bottomsheet).find('*[data-ui="sorter"]'),
      });

      initInputHanlder(bottomsheet, ({ query, items }) => {
        handleAjaxResult(query, items);
      });

      const suggestionItems = $(suggestions).children(".suggestions-item");

      $(suggestionItems).each((index, suggestionItem) => {
        suggestionItemsFeatured.push(suggestionItem);
      });

      function handleSuggestionItems() {
        const suggestionItems = $(suggestions).children("*[data-value]");

        suggestionItems.each((index, suggestionItem) => {
          if ($(suggestionItem).hasClass("active")) {
            const suggestionItemValue = $(suggestionItem)
              .data("value")
              .toString();

            selectedItems.push(suggestionItemValue);
            appliedItems.push(suggestionItemValue);
          }

          $(suggestionItem).on("click", (suggestionItem) => {
            const suggestionItemValue = $(suggestionItem.target).attr(
              "data-value"
            );
            const foundIndex = selectedItems.findIndex(
              (e) => e === suggestionItemValue
            );
            foundIndex === -1
              ? selectedItems.push(suggestionItemValue)
              : selectedItems.splice(foundIndex, 1);

            isHasCganges = true;
            prepareButtons();
          });
        });
      }

      prepareButtons();
      handleSuggestionItems();

      $(clear).on("click", (e) => {
        isHasCganges = true;
        selectedItems = [];
        rebuildList();
        prepareButtons();
      });

      $(apply).on("click", (e) => {
        const filterData = {};
        const selectedItems = [];
        const suggestions = $(bottomsheet).find('*[data-ui="suggestions"]')[0];
        const suggestionItems = $(suggestions).children("*[data-value]");
        const GTM_ITEMS = [];
        const GTM_EVENTS = {
          destination: "applyVenuesDestinationsFilter",
          type: "applyVenuesTypeFilter",
        };

        suggestionItems.each((index, suggestionItem) => {
          if ($(suggestionItem).hasClass("active")) {
            selectedItems.push($(suggestionItem).attr("data-value"));
            GTM_ITEMS.push(suggestionItem.innerHTML.trim());
          }
        });

        if (GTM_EVENTS[filterKey] && GTM_ITEMS.length > 0) {
          dataLayer.push({
            event: GTM_EVENTS[filterKey],
            event_data: GTM_ITEMS.join(","),
          });
        }

        filterData[filterKey] = selectedItems.join(",");

        const urlParams = new URLSearchParams(window.location.search);

        for (const [key, value] of Object.entries(filterData)) {
          if (!value) {
            urlParams.delete(key);
          } else {
            urlParams.set(key, value);
          }
        }

        if ([...urlParams.keys()].length > 0) {
          window.location.search = urlParams;
        } else {
          window.location = window.location.href.split("?")[0];
        }

        closeBottomsheet();
      });

      function prepareButtons() {
        $(apply).addClass("disabled").attr("disabled", "disabled");

        if (
          (isHasCganges && !!appliedItems.length) ||
          (isHasCganges && !!selectedItems.length && !appliedItems.length)
        ) {
          $(apply).removeClass("disabled").removeAttr("disabled", "disabled");
        }
      }

      function openBottomsheet(filter, args) {
        setTimeout(() => {
          $(bottomsheet).css({
            bottom: $(bottomsheet).height() * -1,
          });
        }, 0);

        $("body")
          .addClass("modal-open bottomsheet-open")
          .append('<div class="bottomsheet-backdrop modal-backdrop fade" />');

        forms.suggestions.init();

        if (args.sorter) {
          const sorterItems = $(args.sorter).children(".sorter-item");

          $(sorterItems).each((index, sorterItem) => {
            $(sorterItem).on("click", function () {
              setActiveOrderItem(args.sorter, index);
              const filterLabel = $(filter).children(
                ".dropdown-select-label"
              )[0];
              $(filterLabel).html($(this).html());
              closeBottomsheet();

              $(document).trigger("onFilterOrderChanged", {
                value: $(this).data("value"),
              });
            });
          });
        }

        setTimeout(() => {
          $(".modal-backdrop").addClass("show");
          $(bottomsheet).css({
            bottom: 0,
            opacity: 1,
          });
        }, 150);

        window.preventAppScroll();
      }

      $(bottomsheetCloseTrigger).on("click", () => {
        closeBottomsheet();
      });

      function rebuildList() {
        const suggestions = $(bottomsheet).find('*[data-ui="suggestions"]');
        const suggestionItems = $(suggestions).children("*[data-value]");

        $(suggestionItems).each((index, suggestionItem) => {
          const suggestionItemValue = $(suggestionItem)
            .data("value")
            .toString();
          const foundIndex = selectedItems.findIndex(
            (e) => e === suggestionItemValue
          );

          foundIndex === -1
            ? $(suggestionItem).removeClass("active")
            : $(suggestionItem).addClass("active");
        });
      }

      function handleAjaxResult(query, items) {
        const suggestions = $(bottomsheet).find('*[data-ui="suggestions"]');
        $(suggestions).empty();

        if (query.length === 0) {
          prepareSuggestionItemsFromFeatured();
        } else if (query.length > 0 && items.length === 0) {
          $(suggestions).append(
            `<li class="suggestions-item suggestions-item__no-result">No results for <strong>"${query}"</strong></li>`
          );
          return false;
        } else if (query.length > 0 && items.length > 0) {
          items.forEach((city) => {
            const suggestionItem = $(
              `<li class="suggestions-item" data-value="${city.id}">${city.name}</li>`
            );
            $(suggestions).append(suggestionItem);
          });
        }

        rebuildList();
        prepareButtons();
        handleSuggestionItems();
        forms.suggestions.init();
      }

      function prepareSuggestionItemsFromFeatured() {
        const suggestions = $(bottomsheet).find('*[data-ui="suggestions"]');
        $(suggestions).empty().append(suggestionItemsFeatured);
        prepareButtons();
        handleSuggestionItems();
      }
    });
  });

  $(document).on("click", function (e) {
    if (window.innerWidth >= 810) return true;

    if ($(e.target).hasClass("modal-backdrop")) {
      closeBottomsheet();
    }
  });

  function initInputHanlder(container, callback) {
    const input = $(container).find($('*[data-ui="input"]'));

    $(input)
      .on("input", (e) => {
        if (e.target.value.length === 0) {
          callback({ query: e.target.value, items: [] });
        } else if (e.target.value.length > 2) {
          $.ajax({
            url: `/ajax/cities/search?query=${e.target.value.toLowerCase()}`,
            success: function (data) {
              callback({
                query: e.target.value,
                items: Array.isArray(data) ? data : [],
              });
            },
          });
        }
      })
      .children('*[data-action="clear"]')
      .on("click", (e) => {
        callback({ query: e.target.value, items: [] });
      });
  }

  function setActiveOrderItem(sorter, index) {
    $(sorter)
      .children()
      .each((i, e) => {
        $(e).removeClass("active");
        if (index === i) {
          $(e).addClass("active");
        }
      });
  }

  function closeBottomsheet() {
    $("body").removeClass(["modal-open", "bottomsheet-open"]);
    $(".modal-backdrop").removeClass("show");
    $(activeBottomsheet).css({ bottom: $(activeBottomsheet).height() * -1 });
    setTimeout(() => {
      $(".modal-backdrop").remove();
      $(activeBottomsheet).remove();
    }, 150);

    window.restoreAppScroll();
  }
});
